<!--
  elcSgnComp.vue ( etc, mblElcsgn06 )
  - 전자서명 완료 페이지
 -->
<template>
  <div id="wrap" class="wrap_layout">
    <!--Header [s]-->
    <Header
      :rtrnAnimInsYn="state.rtrnAnimInsYn"
      :ernpeDivNm="state.ernpeDivNm"
    />
    <!--Header [e]-->
    <!-- Container [s] -->
    <div class="container type_complete">
      <!-- 완료페이지만 : type_complete 클래스 적용 -->
      <div class="contents">
        <!--Contents Area [s]-->
        <div class="section">
          <div class="finish_wrap">
            <p>
              메리츠화재 모바일 피보험자 전자서명이 완료되었습니다.<br />이용해주셔서
              감사합니다.
            </p>
          </div>
          <div class="btn_area">
            <button type="button" class="btn_main" @click="goHome">
              <span>홈으로 이동</span>
            </button>
          </div>
        </div>
      </div>
    </div>
    <Footer :rtrnAnimInsYn="state.rtrnAnimInsYn" />
  </div>
</template>

<script>
import { reactive, onMounted } from "vue";
import { sessionUserInfo, load } from "@/common/sessionFactory";
import { useRouter, useRoute } from "vue-router";
import Header from "@/components/common/Header.vue";
import Footer from "@/components/common/Footer.vue";
import util from "@/common/util";

export default {
  name: "elcSgnComp",
  components: {
    Header,
    Footer,
  },
  setup() {
    const router = useRouter();

    var state = reactive({
      mode: process.env.NODE_ENV,
    });

    onMounted(async () => {
      util.saveLog("009", "전자서명완료"); // 009 : 화면진입
    });

    const goHome = () => {
      let url = "";
      if (state.mode == "development") {
        url = "https://mdev.meritzfire.com:16541/main.do";
      } else {
        url = "https://m.meritzfire.com/main.do";
      }
      location.href = url;
    };

    return {
      state,
      goHome,
    };
  },
};
</script>
